import { useEffect, useRef } from "react";
import { useTrackFn } from "./useTrackFn";
export function useViewTrack(params) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var lockRef = useRef(false);
  var onTrack = useTrackFn(params);
  useEffect(function () {
    // 防止依赖变更多次触发
    if (lockRef.current) {
      return;
    }
    var result = onTrack();
    if (result) {
      lockRef.current = true;
    }
  }, deps);
}